export default __webpack_public_path__ + "alberta-immunotherapy.e1358f592b9c964887c0.svg";